import { render, staticRenderFns } from "./addBackModal.vue?vue&type=template&id=05dca26b&scoped=true&"
import script from "./addBackModal.vue?vue&type=script&lang=js&"
export * from "./addBackModal.vue?vue&type=script&lang=js&"
import style0 from "./addBackModal.vue?vue&type=style&index=0&id=05dca26b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dca26b",
  null
  
)

export default component.exports